import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: () => import("@/view/pages/Dashboard.vue")
                },
                {
                    path: "/farmer",
                    name: "farmer",
                    component: () => import("@/view/pages/Farmer.vue")
                },
                {
                    path: "/farmer/create",
                    name: "farmer-create",
                    component: () => import("@/view/pages/Farmer/Edit")
                },
                {
                    path: "/farmer/:id",
                    name: "farmer-show",
                    component: () => import("@/view/pages/Farmer/Show")
                },
                {
                    path: "/farmer/:id/edit",
                    name: "farmer-edit",
                    component: () => import("@/view/pages/Farmer/Edit")
                }
            ]
        },
        {
            path: "/error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
            children: [
                {
                    path: "error",
                    name: "error-3",
                    component: () => import("@/view/pages/error/Error-3.vue")
                }
            ]
        },
        {
            path: "/",
            component: () => import("@/view/pages/auth/Auth"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/view/pages/auth/Login")
                }
            ]
        },
        {
            path: "*",
            redirect: "/404"
        },
        {
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error-3.vue")
        }
    ]
});
